<mat-form-field>
  <input matInput placeholder="{{ placeholder }}" [formControl]="inputControl" [ngxTimepicker]="picker" [format]="24" [disableClick]="disableClick" (focusout)="focusOut(minGapIntern)" (focus)="focusIn(1)" />
  <ngx-material-timepicker-toggle [for]="picker"></ngx-material-timepicker-toggle>
</mat-form-field>
<ngx-material-timepicker #picker [minutesGap]="minGap"></ngx-material-timepicker>
